export const isTokenExpired = (tokenData) => {
  if (!tokenData || !tokenData.expires_in) return true;

  const expiryTime =
    tokenData.created_at + tokenData.expires_in * 1000;

  return Date.now() > expiryTime;
};

export const saveToken = (token) => {
  const tokenData = {
    ...token,
    created_at: Date.now(),
  };

  localStorage.setItem("token_gen", JSON.stringify(tokenData));
};

export const getSavedToken = () => {
  const data = localStorage.getItem("token_gen");
  return data ? JSON.parse(data) : null;
};

export const removeToken = () => {
  localStorage.removeItem("token_gen");
};